export enum HealthAnalysisRecollectOrigin {
    USER = 'USER',
    PRESCRIBER = 'PRESCRIBER',
    CIERA = 'CIERA'
}
